import usePresentSelector from './usePresentSelector';
import CropGridValueWrapper from './CropGridValueWrapper';
import CropWrapper from './CropWrapper'; 
import FigureText from './FigureText';
import FigureImageExpansionContainer from './FigureImageExpansionContainer';
import BandAnnotation from './BandAnnotation';

export default function RenderedValue(props){

  let {

    textStyle,

    editable,

    isAdjustingCropVertically,

    figurePanelId,
    value,width,expandImage,gridCellId,cellLocation,
    tdBounds, tdRef, cell, textBounds, rotatedRectHeight,
    tableOutlineShowing,
  } = props;


  if(!figurePanelId){
    throw Error("figurePanelId cannot be undefined.");
  }

  if( value instanceof Object ){
    if( value.valueType === 'imageTemplate'){
      return <div style={{overflow:'scroll'}}>{JSON.stringify(value)}</div>
    }
    else if( value.valueType === 'crop' ){

      if( value.expandable ){



        return (
          <FigureImageExpansionContainer 
            figurePanelId={figurePanelId}
            value={value}
            onCellInteractionEvent={props.onCellInteractionEvent}
            width={width}
            cellLocation={cellLocation}/>
        )
      }


      return (
        <CropGridValueWrapper 
          key={"crop-"+value.annotationId}
          {...{
            editable,
            placementEditable:editable,
            tableOutlineShowing,
            value,
            width,
            gridCellId,
            expandImage,
            figurePanelId,
            cellLocation,
            cell,
          }}/>
      );
    }else if( value.value !== undefined && value.value.valueType === 'bandAnnotation' ){
      if( !cellLocation ){
        throw Error("cell undefined");
      }
      if( isAdjustingCropVertically ){
        return null;
      }
      return <BandAnnotation {...{
        bandsEditable:false, 
        editable,
        value:value.value, 
        width, 
        cell:cellLocation, 
        style:value.style,
        figurePanelId,
      }}/>
    }else{
      return <div style={{color:'red'}}>{JSON.stringify(value)}</div>
    }
  }else if( typeof(value) === 'string' ){

    let ft = extras => <FigureText {...{
      textStyle,
      textBounds,
      rotatedRectHeight,
      value,
      cell,
      cellLocation,
      tdBounds,
      tdRef,
      ...extras
    }}/>

    return <>
      {ft({ showHtmlProps:true })}
      <div class="for-svg-positioning" style={{position: 'absolute', visibility: 'hidden'}}>
        {ft({ dontRotate: true })}
      </div>
    </>

  }else{
    return (
      <div style={{color:'red'}}>
        {value}
      </div>
    )
  }
}

